export default "__VITE_ASSET__DZD_8Etf__"